import { CImg, CInputGroup, CLabel } from '@coreui/react';
import * as React from 'react';
import { KComplements, KControlAddon } from '../';
import { IImageProvider } from '../../abstraction';
import { Utils } from '../../core/utils';
import offImg from '../../img/Toggle_OFF.png';
import onImg from '../../img/Toggle_ON.png';
import { ControlModel } from '../../models/index';

interface IProps {
	control: ControlModel
	showLabel?: boolean;
	showComplements?: boolean;
	onChange?: (value: string) => void;
	imageProvider: IImageProvider;
}

interface IState {
	currentControl: ControlModel
}

export class KControlCheckbox extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			currentControl: this.props.control,
		}
	}

	//#region local events
	onChange = (event) => {
		if (this.props.control.Disable) return;

		if (this.props.control.Value == "1") {
			this.props.control.Value = "2";
		}
		else {
			this.props.control.Value = "1";
		}

		this.setState({ currentControl: this.state.currentControl })

		if (this.props.onChange) this.props.onChange(this.props.control.Value);
	}

	//#endregion 

	//#region Rendus 

	renderImg = () => {
		if (this.state.currentControl.Value == "2") {
			return (<CImg src={onImg}></CImg>);
		}
		else {
			return (<CImg src={offImg}></CImg>);
		}
	}

	renderComplements = () => {
		if (this.props.showComplements) return <KComplements Control={this.state.currentControl} />
		return "";
	}

	render() {
		let ctrl = this.state.currentControl;
		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);
		let gangnamStyle = Utils.decodeInlineStyleFromJson(ctrl.InputInlineStyle);

		let bsSize = Utils.getColSizeClasses(ctrl);
		let img = this.renderImg();
		let complements = this.renderComplements();

		let header = (this.props.showLabel) ? <CLabel htmlFor={this.props.control.Key} ></CLabel> : "";

		//
		return (
			<div className={`KControl KControlCheckbox ${ctrl.Class} ${bsSize}`} style={inlineStyle}  >
				{header}

				<CInputGroup onClick={this.onChange} id={this.props.control.Key} style={gangnamStyle} >
					<KControlAddon imageProvider={this.props.imageProvider} type="prepend" image={ctrl.PrependImage} text={ctrl.PrependText} visibilityCondition={ctrl.PreVisibilityCond} />
					{img}
					<CLabel>{ctrl.Description}</CLabel>
				</CInputGroup>

				{complements}
			</div>
		)
	}

	//#endregion 
} 